import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import 'components/Inputs/Checkbox/styles.scss';

interface Props {
  checked?: boolean;
  label?: string;
  id: string;
  readonly?: boolean;
  secondLabel?: string;
  onChange: (number, any) => void;
}

const handleChange = (e, id, onChange) => {
  e.stopPropagation();
  onChange(id, e);
};

const Checkbox: React.FC<Props> = ({
  checked = false,
  id,
  label = '',
  readonly = false,
  secondLabel = '',
  onChange,
}) => {
  const checkBoxClasses = classNames({
    checkbox: true,
    readonly: readonly,
  });
  const checkMarkClasses = classNames({
    'check-mark': true,
    checked: checked,
    readonly: readonly,
  });
  return (
    <label className={checkBoxClasses} htmlFor={id}>
      {label !== '' ? (
        <div className="labels">
          <span>{label}</span>
          {secondLabel !== '' && <span className="second-label">{secondLabel}</span>}
        </div>
      ) : null}
      <input
        checked={checked}
        readOnly={readonly}
        id={id}
        type="checkbox"
        onChange={(e) => handleChange(e, id, onChange)}
      />
      <span className={checkMarkClasses}>{checked && <FontAwesomeIcon icon={faCheck} />}</span>
    </label>
  );
};

export default Checkbox;
